<ng-container *transloco="let t">
  @if (displayItemQuantities()) {
    <pxw-counter [(count)]="productQuantity" [min]="1" [max]="maxQuantity()" />
  }
  <pxw-button
    class="submit-button"
    mode="submit"
    [formId]="formId()"
    color="yellow"
    size="lg"
    [rounded]="true"
    [disabled]="disabled() || hasStockIssues()"
  >
    <span class="add-product-label">{{ buttonText() }}</span>
    <pxw-product-detail-subtotal
      [price]="cartItemSubtotal()"
      [priceDiscount]="cartItemSubtotalWithDiscount()"
    />
  </pxw-button>
</ng-container>
